module.exports = __webpack_public_path__ + "static/media/223.53ae7eb2.webp";